/**
 * For Intl formatting, 'default' refers to Intl.DateTimeFormat().resolvedOptions().locale, which
 * - In Chrome: (chrome://settings/languages) the language labeled "This language is used to
 *   display the Google Chrome UI"
 * - In Firefox: (about:preferences) the language selected for "Choose the language used to
 *   display menus, messages, and notifications from Firefox"
 */
export const DEFAULT_LOCALE = 'default';

export const DEFAULT_CURRENCY = 'USD';

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl
export enum IntlFormat {
  Collator = 'Collator',
  DateTimeFormat = 'DateTimeFormat',
  DisplayNames = 'DisplayNames',
  // ListFormat = 'ListFormat',
  NumberFormat = 'NumberFormat',
  PluralRules = 'PluralRules',
  RelativeTimeFormat = 'RelativeTimeFormat',
  // Segmenter = 'Segmenter',
}
